"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateFormat = exports.findDateAttributeUris = void 0;
// (C) 2020-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var dateValueFormatter_1 = require("./dateValueFormatter");
var dateValueParser_1 = require("./dateValueParser");
var defaultDateFormatter_1 = require("./defaultDateFormatter");
// TODO: rewrite. move search for date attributes into data view facade / meta() section
function findDateAttributeUris(dimensions) {
    var dateAttrsDescriptor = dimensions
        .reduce(function (attrDimensions, dimensionItem) {
        attrDimensions.push.apply(attrDimensions, dimensionItem.headers.filter(sdk_backend_spi_1.isAttributeDescriptor));
        return attrDimensions;
    }, [])
        .filter(function (attrDescriptor) {
        return attrDescriptor.attributeHeader.type === "GDC.time.day_us";
    });
    return dateAttrsDescriptor.map(function (dateAttrDescriptor) { return dateAttrDescriptor.attributeHeader.formOf.uri; });
}
exports.findDateAttributeUris = findDateAttributeUris;
function transformDateFormat(resultHeader, dateAttributeUris, dateFormat) {
    if (!sdk_backend_spi_1.isResultAttributeHeader(resultHeader) ||
        !(dateAttributeUris === null || dateAttributeUris === void 0 ? void 0 : dateAttributeUris.length) ||
        !dateFormat ||
        dateFormat === dateValueParser_1.DEFAULT_DATE_FORMAT) {
        return resultHeader;
    }
    var resultHeaderUri = resultHeader.attributeHeaderItem.uri;
    var foundUri = dateAttributeUris.some(function (dateAttributeUri) {
        return resultHeaderUri.startsWith(dateAttributeUri);
    });
    if (!foundUri) {
        return resultHeader;
    }
    try {
        var dateValueFormatter = dateValueFormatter_1.createDateValueFormatter(defaultDateFormatter_1.createDefaultDateFormatter(dateFormat));
        return {
            attributeHeaderItem: {
                name: dateValueFormatter(resultHeader.attributeHeaderItem.name),
                uri: resultHeaderUri,
            },
        };
    }
    catch (_a) {
        return resultHeader;
    }
}
exports.transformDateFormat = transformDateFormat;
//# sourceMappingURL=dateFormatter.js.map